import { EPermissionResource } from 'views/types/permissions';

export const PERMISSION_RESOURCES = {
  // Dashboard & Analytics
  DASHBOARD: EPermissionResource.DASHBOARD,
  TOTAL_USERS: EPermissionResource.TOTAL_USERS,
  TOTAL_CARD_BALANCE: EPermissionResource.TOTAL_CARD_BALANCE,
  TOTAL_ISSUED_CARDS: EPermissionResource.TOTAL_ISSUED_CARDS,
  TOTAL_ACTIVE_CARDS: EPermissionResource.TOTAL_ACTIVE_CARDS,
  TOTAL_TRANSACTIONS: EPermissionResource.TOTAL_TRANSACTIONS,
  TOTAL_VOLUME: EPermissionResource.TOTAL_VOLUME,
  TOTAL_CLIENTS_WALLET_BALANCE:
    EPermissionResource.TOTAL_CLIENTS_WALLET_BALANCE,
  REFERRAL_COUNT: EPermissionResource.REFERRAL_COUNT,

  // New Dashboard Resources
  DEPOSIT_TRANSACTIONS: EPermissionResource.DEPOSIT_TRANSACTIONS,
  INTERNAL_SEND_TRANSACTIONS: EPermissionResource.INTERNAL_SEND_TRANSACTIONS,
  CRYPTO_TRANSFERS_WITHDRAWALS:
    EPermissionResource.CRYPTO_TRANSFERS_WITHDRAWALS,
  CARD_ISSUE_ATTEMPTS: EPermissionResource.CARD_ISSUE_ATTEMPTS,
  CARD_TOP_UP_TRANSACTIONS: EPermissionResource.CARD_TOP_UP_TRANSACTIONS,
  SWAP_TRANSACTIONS: EPermissionResource.SWAP_TRANSACTIONS,

  // Transaction Management
  TRANSACTIONS_PAGE: EPermissionResource.TRANSACTIONS_PAGE,
  SEARCH_BUTTON_TRANSACTIONS: EPermissionResource.SEARCH_BUTTON_TRANSACTIONS,
  FILTER_TRANSACTIONS: EPermissionResource.FILTER_TRANSACTIONS,
  TRANSACTION_INNER_PAGE: EPermissionResource.TRANSACTION_INNER_PAGE,

  // Client Management
  CLIENTS_LIST: EPermissionResource.CLIENTS_LIST,
  SEARCH_BUTTON: EPermissionResource.SEARCH_BUTTON,
  FILTER: EPermissionResource.FILTER,
  CLIENT_PROFILE: EPermissionResource.CLIENT_PROFILE,
  BLOCK_CTA: EPermissionResource.BLOCK_CTA,
  KYC_CTA: EPermissionResource.KYC_CTA,
  INFO: EPermissionResource.INFO,
  TRANSACTIONS: EPermissionResource.TRANSACTIONS,
  REFERRALS: EPermissionResource.REFERRALS,
  LOGS: EPermissionResource.LOGS,
  CARDS: EPermissionResource.CARDS,
  WALLETS: EPermissionResource.WALLETS,
  CLIENT_BALANCE_EDIT: EPermissionResource.CLIENT_BALANCE_EDIT,

  // Support Management
  SUPPORT_CHATS: EPermissionResource.SUPPORT_CHATS,
  LEAVE_CHAT_CTA: EPermissionResource.LEAVE_CHAT_CTA,
  SEND_CTA: EPermissionResource.SEND_CTA,
  SUPPORT_TICKETS: EPermissionResource.SUPPORT_TICKETS,
  CREATE_SUPPORT_TICKET_CTA: EPermissionResource.CREATE_SUPPORT_TICKET_CTA,
  FILTER_BUTTON_SUPPORT: EPermissionResource.FILTER_BUTTON_SUPPORT,
  SEARCH_BUTTON_SUPPORT: EPermissionResource.SEARCH_BUTTON_SUPPORT,
  FILTER_BY_ASSIGNED_ADMIN: EPermissionResource.FILTER_BY_ASSIGNED_ADMIN,
  GET_ALL_TICKETS: EPermissionResource.GET_ALL_TICKETS,
  GET_BY_TICKET_ID: EPermissionResource.GET_BY_TICKET_ID,
  GET_ALL_BY_CLIENT_ID: EPermissionResource.GET_ALL_BY_CLIENT_ID,
  TICKET_INNER_MENU: EPermissionResource.TICKET_INNER_MENU,

  // Admin Management
  TOKENS_INFO: EPermissionResource.TOKENS_INFO,
  ADMINS: EPermissionResource.ADMINS,
  CREATE_ADMIN: EPermissionResource.CREATE_ADMIN,
  FILTER_ADMINS: EPermissionResource.FILTER_ADMINS,
  ASSIGN_ROLE: EPermissionResource.ASSIGN_ROLE,
  ACTIVE_INACTIVE_CTA: EPermissionResource.ACTIVE_INACTIVE_CTA,
  PENDING_VERIFICATION: EPermissionResource.PENDING_VERIFICATION,
  CONFIRM_CANCEL_CTA: EPermissionResource.CONFIRM_CANCEL_CTA,
  PERMISSION_MANAGEMENT: EPermissionResource.PERMISSION_MANAGEMENT,
  PASSWORD: EPermissionResource.PASSWORD,
  ADMIN_LOGS: EPermissionResource.ADMIN_LOGS,

  // Action Permissions
  APPROVE_CTA: EPermissionResource.APPROVE_CTA,
  REJECT_CTA: EPermissionResource.REJECT_CTA,
  WALLET_ADDRESS_INPUT: EPermissionResource.WALLET_ADDRESS_INPUT,

  // Settlement & Solvency
  SOLVENCY: EPermissionResource.SOLVENCY,
  ORDER_QUEUE: EPermissionResource.ORDER_QUEUE,

  // Communication
  PUBLIC_NOTIFICATIONS: EPermissionResource.PUBLIC_NOTIFICATIONS,

  // Fees Management
  FEES: EPermissionResource.FEES,
} as const;

export const ROUTE_TO_RESOURCE_MAP: Record<string, string> = {
  dashboard: PERMISSION_RESOURCES.DASHBOARD,
  clients: PERMISSION_RESOURCES.CLIENTS_LIST,
  transactions: PERMISSION_RESOURCES.TRANSACTIONS_PAGE,
  'support-chats': PERMISSION_RESOURCES.SUPPORT_CHATS,
  'support-tickets': PERMISSION_RESOURCES.SUPPORT_TICKETS,
  'token-info': PERMISSION_RESOURCES.TOKENS_INFO,
  manage: PERMISSION_RESOURCES.ADMINS,
  kyc: PERMISSION_RESOURCES.PENDING_VERIFICATION,
  permissions: PERMISSION_RESOURCES.PERMISSION_MANAGEMENT,
  solvency: PERMISSION_RESOURCES.SOLVENCY,
  'order-queue': PERMISSION_RESOURCES.ORDER_QUEUE,
  'rebalance-center': PERMISSION_RESOURCES.ORDER_QUEUE,
  'public-notifications': PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS,
  fees: PERMISSION_RESOURCES.FEES,
} as const;

export const RESOURCE_CATEGORIES = {
  'Dashboard & Analytics': [
    PERMISSION_RESOURCES.DASHBOARD,
    PERMISSION_RESOURCES.TOTAL_USERS,
    PERMISSION_RESOURCES.TOTAL_CARD_BALANCE,
    PERMISSION_RESOURCES.TOTAL_ISSUED_CARDS,
    PERMISSION_RESOURCES.TOTAL_ACTIVE_CARDS,
    PERMISSION_RESOURCES.TOTAL_TRANSACTIONS,
    PERMISSION_RESOURCES.TOTAL_VOLUME,
    PERMISSION_RESOURCES.TOTAL_CLIENTS_WALLET_BALANCE,
    PERMISSION_RESOURCES.REFERRAL_COUNT,
    PERMISSION_RESOURCES.DEPOSIT_TRANSACTIONS,
    PERMISSION_RESOURCES.INTERNAL_SEND_TRANSACTIONS,
    PERMISSION_RESOURCES.CRYPTO_TRANSFERS_WITHDRAWALS,
    PERMISSION_RESOURCES.CARD_ISSUE_ATTEMPTS,
    PERMISSION_RESOURCES.CARD_TOP_UP_TRANSACTIONS,
    PERMISSION_RESOURCES.SWAP_TRANSACTIONS,
  ],
  'Transaction Management': [
    PERMISSION_RESOURCES.TRANSACTIONS_PAGE,
    PERMISSION_RESOURCES.SEARCH_BUTTON_TRANSACTIONS,
    PERMISSION_RESOURCES.FILTER_TRANSACTIONS,
    PERMISSION_RESOURCES.TRANSACTION_INNER_PAGE,
    PERMISSION_RESOURCES.APPROVE_CTA,
    PERMISSION_RESOURCES.REJECT_CTA,
    PERMISSION_RESOURCES.WALLET_ADDRESS_INPUT,
  ],
  'Client Management': [
    PERMISSION_RESOURCES.CLIENTS_LIST,
    PERMISSION_RESOURCES.SEARCH_BUTTON,
    PERMISSION_RESOURCES.FILTER,
    PERMISSION_RESOURCES.CLIENT_PROFILE,
    PERMISSION_RESOURCES.BLOCK_CTA,
    PERMISSION_RESOURCES.KYC_CTA,
    PERMISSION_RESOURCES.INFO,
    PERMISSION_RESOURCES.TRANSACTIONS,
    PERMISSION_RESOURCES.REFERRALS,
    PERMISSION_RESOURCES.LOGS,
    PERMISSION_RESOURCES.CARDS,
    PERMISSION_RESOURCES.WALLETS,
    PERMISSION_RESOURCES.CLIENT_BALANCE_EDIT,
  ],
  'Support Management': [
    PERMISSION_RESOURCES.SUPPORT_CHATS,
    PERMISSION_RESOURCES.LEAVE_CHAT_CTA,
    PERMISSION_RESOURCES.SEND_CTA,
    PERMISSION_RESOURCES.FILTER_BUTTON_SUPPORT,
    PERMISSION_RESOURCES.SEARCH_BUTTON_SUPPORT,
    PERMISSION_RESOURCES.SUPPORT_TICKETS,
    PERMISSION_RESOURCES.TICKET_INNER_MENU,
    PERMISSION_RESOURCES.CREATE_SUPPORT_TICKET_CTA,
    PERMISSION_RESOURCES.FILTER_BY_ASSIGNED_ADMIN,
    PERMISSION_RESOURCES.GET_ALL_TICKETS,
    PERMISSION_RESOURCES.GET_BY_TICKET_ID,
    PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID,
  ],
  'User Management': [
    PERMISSION_RESOURCES.ADMINS,
    PERMISSION_RESOURCES.CREATE_ADMIN,
    PERMISSION_RESOURCES.PASSWORD,
    PERMISSION_RESOURCES.PERMISSION_MANAGEMENT,
    PERMISSION_RESOURCES.FILTER_ADMINS,
    PERMISSION_RESOURCES.ASSIGN_ROLE,
    PERMISSION_RESOURCES.ACTIVE_INACTIVE_CTA,
    PERMISSION_RESOURCES.ADMIN_LOGS,
  ],
  'Token Info Management': [PERMISSION_RESOURCES.TOKENS_INFO],
  'Pending Verification Management': [
    PERMISSION_RESOURCES.PENDING_VERIFICATION,
    PERMISSION_RESOURCES.CONFIRM_CANCEL_CTA,
  ],
  'Settlement & Solvency': [
    PERMISSION_RESOURCES.SOLVENCY,
    PERMISSION_RESOURCES.ORDER_QUEUE,
  ],
  Communication: [PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS],
  'Fees Management': [PERMISSION_RESOURCES.FEES],
  // 'Action Permissions': [
  //   PERMISSION_RESOURCES.APPROVE_CTA,
  //   PERMISSION_RESOURCES.REJECT_CTA,
  //   PERMISSION_RESOURCES.WALLET_ADDRESS_INPUT,
  // ],
} as const;

export const RESOURCE_DISPLAY_NAMES: Record<string, string> = {
  [PERMISSION_RESOURCES.DASHBOARD]: 'Dashboard',
  [PERMISSION_RESOURCES.TOTAL_USERS]: 'Total Users',
  [PERMISSION_RESOURCES.TOTAL_CARD_BALANCE]: 'Total Card Balance',
  [PERMISSION_RESOURCES.TOTAL_ISSUED_CARDS]: 'Total Issued Cards',
  [PERMISSION_RESOURCES.TOTAL_ACTIVE_CARDS]: 'Total Active Cards',
  [PERMISSION_RESOURCES.TOTAL_TRANSACTIONS]: 'Total Transactions',
  [PERMISSION_RESOURCES.TOTAL_VOLUME]: 'Total Volume',
  [PERMISSION_RESOURCES.TOTAL_CLIENTS_WALLET_BALANCE]:
    'Total Clients Wallet Balance',
  [PERMISSION_RESOURCES.REFERRAL_COUNT]: 'Referral Count',
  [PERMISSION_RESOURCES.DEPOSIT_TRANSACTIONS]: 'Deposit Transactions',
  [PERMISSION_RESOURCES.INTERNAL_SEND_TRANSACTIONS]:
    'Internal (Send) Transactions',
  [PERMISSION_RESOURCES.CRYPTO_TRANSFERS_WITHDRAWALS]:
    'Crypto Transfers (Withdrawals)',
  [PERMISSION_RESOURCES.CARD_ISSUE_ATTEMPTS]: 'Card Issue Attempts',
  [PERMISSION_RESOURCES.CARD_TOP_UP_TRANSACTIONS]: 'Card Top Up Transactions',
  [PERMISSION_RESOURCES.SWAP_TRANSACTIONS]: 'Swap Transactions',
  [PERMISSION_RESOURCES.TRANSACTIONS_PAGE]: 'Transactions Page',
  [PERMISSION_RESOURCES.SEARCH_BUTTON_TRANSACTIONS]:
    'Search Button (Transactions)',
  [PERMISSION_RESOURCES.FILTER_TRANSACTIONS]: 'Filter (Transactions)',
  [PERMISSION_RESOURCES.TRANSACTION_INNER_PAGE]: 'Transaction Inner Page',
  [PERMISSION_RESOURCES.CLIENTS_LIST]: 'Clients List',
  [PERMISSION_RESOURCES.SEARCH_BUTTON]: 'Search Button',
  [PERMISSION_RESOURCES.FILTER]: 'Filter',
  [PERMISSION_RESOURCES.CLIENT_PROFILE]: 'Client Profile',
  [PERMISSION_RESOURCES.BLOCK_CTA]: 'Block CTA',
  [PERMISSION_RESOURCES.KYC_CTA]: 'KYC CTA',
  [PERMISSION_RESOURCES.INFO]: 'Info',
  [PERMISSION_RESOURCES.TRANSACTIONS]: 'Transactions',
  [PERMISSION_RESOURCES.REFERRALS]: 'Referrals',
  [PERMISSION_RESOURCES.LOGS]: 'Logs',
  [PERMISSION_RESOURCES.CARDS]: 'Cards',
  [PERMISSION_RESOURCES.WALLETS]: 'Wallets',
  [PERMISSION_RESOURCES.CLIENT_BALANCE_EDIT]: 'Edit Wallet Balance',
  [PERMISSION_RESOURCES.SUPPORT_CHATS]: 'Support Chats',
  [PERMISSION_RESOURCES.LEAVE_CHAT_CTA]: 'Leave Chat CTA',
  [PERMISSION_RESOURCES.SEND_CTA]: 'Send CTA',
  [PERMISSION_RESOURCES.SUPPORT_TICKETS]: 'Support Tickets',
  [PERMISSION_RESOURCES.CREATE_SUPPORT_TICKET_CTA]: 'Create Support Ticket CTA',
  [PERMISSION_RESOURCES.FILTER_BUTTON_SUPPORT]: 'Filter Button Support',
  [PERMISSION_RESOURCES.SEARCH_BUTTON_SUPPORT]: 'Search Button Support',
  [PERMISSION_RESOURCES.FILTER_BY_ASSIGNED_ADMIN]: 'Filter by Assigned Admin',
  [PERMISSION_RESOURCES.GET_ALL_TICKETS]: 'Get All Tickets',
  [PERMISSION_RESOURCES.GET_BY_TICKET_ID]: 'Get by Ticket ID',
  [PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID]: 'Get All by Client ID',
  [PERMISSION_RESOURCES.TICKET_INNER_MENU]: 'Ticket Inner Menu',
  [PERMISSION_RESOURCES.TOKENS_INFO]: 'Tokens Info',
  [PERMISSION_RESOURCES.ADMINS]: 'Admins',
  [PERMISSION_RESOURCES.CREATE_ADMIN]: 'Create Admin',
  [PERMISSION_RESOURCES.FILTER_ADMINS]: 'Filter (Admins)',
  [PERMISSION_RESOURCES.PERMISSION_MANAGEMENT]: 'Permission Management',
  [PERMISSION_RESOURCES.ASSIGN_ROLE]: 'Assign Role',
  [PERMISSION_RESOURCES.ACTIVE_INACTIVE_CTA]: 'Active/Inactive CTA',
  [PERMISSION_RESOURCES.PENDING_VERIFICATION]: 'Pending Verification',
  [PERMISSION_RESOURCES.CONFIRM_CANCEL_CTA]: 'Confirm/Cancel CTA',
  [PERMISSION_RESOURCES.PASSWORD]: 'Admin Password',
  [PERMISSION_RESOURCES.ADMIN_LOGS]: 'Admin Logs',
  [PERMISSION_RESOURCES.APPROVE_CTA]: 'Approve CTA',
  [PERMISSION_RESOURCES.REJECT_CTA]: 'Reject CTA',
  [PERMISSION_RESOURCES.WALLET_ADDRESS_INPUT]: 'Wallet Address Input',
  [PERMISSION_RESOURCES.SOLVENCY]: 'Solvency',
  [PERMISSION_RESOURCES.ORDER_QUEUE]: 'Order Queue',
  [PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS]: 'Public Notifications',
  [PERMISSION_RESOURCES.FEES]: 'Fees Management',
} as const;
